<template>
	<p v-if="hasPromo">
		Book directly through our website and get
		<TextUnderline>10%</TextUnderline>
		off your total booking.
		<br class="hidden xl:block" />
		Reserve your car now!
	</p>
</template>

<script setup>
import TextUnderline from '@/Components/TextUnderline.vue'

const hasPromo = import.meta.env.VITE_PROMOCODE || null
</script>
